import {
  put,
  takeEvery,
  call
} from 'redux-saga/effects';

import * as actions from '../../actions';
import * as actionTypes from '../../actionTypes/ActionTypes';
import companyUsersAssignPaymentServices from '../../../services/companyUsersAssignPaymentServices';

export default function* updateCompanyUsersAssignPaymentSaga() {
  yield takeEvery(actionTypes.COMPANY_USERS_ASSIGN_PAYMENT.UPDATE_COMPANY_USERS_ASSIGN_PAYMENT_REQUEST, updateCompanyUsersAssignPayment);
}

export function* updateCompanyUsersAssignPayment(action) {
  try {
    const response = yield call(companyUsersAssignPaymentServices.update, action.payload);
    if (response.success) {
      yield put(actions.companyUsersAssignPayment.updateSuccess(response.data));
    } else {
      yield put(actions.companyUsersAssignPayment.updateFail(response.data));
    }
  } catch (error) {
    yield put(actions.companyUsersAssignPayment.updateFail(error));
  }
}
